import React from 'react';
import PropTypes from 'prop-types';
import {
  LAYOUT_1_0, LAYOUT_1_2, LAYOUT_2_0, LAYOUT_2_2
} from '../../constants';
import FullWidth from './FullWidth';
import SplitScreenItem from './SplitScreen';
import { Consumer as HomepageContext } from '../../context';

const Item = props => (
  <HomepageContext>
    {(context) => {
      if (props.layout === LAYOUT_1_0) {
        return (
          <FullWidth
            {...props}
            guest={context.guest}
            orderReference={props.orderReference}
          />
        );
      }
      return (
        <SplitScreenItem
          {...props}
          guest={context.guest}
          orderReference={props.orderReference}
        />
      );
    }}
  </HomepageContext>
);

Item.propTypes = {
  appearance: PropTypes.string,
  className: PropTypes.string,
  guest: PropTypes.bool,
  orderReference: PropTypes.string.isRequired,
  orderDate: PropTypes.string.isRequired,
  orderStatus: PropTypes.shape({
    tag: PropTypes.string,
    positive: PropTypes.bool
  }).isRequired,
  orderTitle: PropTypes.string,
  mainProduct: PropTypes.shape({
    productId: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    productUrl: PropTypes.string
  }).isRequired,
  numberOfProducts: PropTypes.number,
  plusItemsMessage: PropTypes.string,
  registerAccountMessageStart: PropTypes.string,
  registerAccountMessageEnd: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string
  })),
  layout: PropTypes.oneOf([
    LAYOUT_1_0,
    LAYOUT_1_2,
    LAYOUT_2_0,
    LAYOUT_2_2
  ]).isRequired,
  onRegisterAccountLinkClicked: PropTypes.func
};

Item.defaultProps = {
  appearance: 'box',
  className: undefined,
  guest: false,
  links: [],
  numberOfProducts: 0,
  orderTitle: 'Order no. [ORDER_REFERENCE]',
  plusItemsMessage: '+ [NUMBER_OF_ITEMS] more item[S]',
  registerAccountMessageStart: 'Register for an account',
  registerAccountMessageEnd:
    'to <strong>track your order</strong> and <strong>view details.</strong>',
  onRegisterAccountLinkClicked: () => {}
};

export default Item;
